export default "<div class=\"panel\">\n  <app-workspace></app-workspace>\n</div>"